import getters from './getters';
import actions from './actions';
import mutations from './mutations';
export var state = () => ({
  newRelicScript: ''
});
export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};